export const ALL = 'All';
export const ALL_FILTERS = {
  label: ALL,
  value: null,
};

export const ANALYTICS_EVENT_NAMES = {
  ADD_PRODUCT_TO_BASKET: 'Add product to basket',
  REMOVE_PRODUCT_FROM_BASKET: 'Remove product from basket',
};

export const OrderStatus = {
  CREATED: 'CREATED',
  CONFIRMED: 'CONFIRMED',
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  IN_PROGRESS: 'IN_PROGRESS',
  CANCELLED: 'CANCELLED',
  READY_FOR_COLLECTION: 'READY_FOR_COLLECTION',
  COLLECTED: 'COLLECTED',
  DELIVERED: 'DELIVERED',
  ON_THE_WAY: 'ON_THE_WAY',
};
